import React from 'react';
import ProgressChartLabel from './ProgressChartLabel';
import ProgressBar from './ProgressBar';

const ProgressChart = ({ data: { total, level1, level2, level3 } = {} }) => {
  return (
    <div className="progress-chart">
      <div className="flex flex-col xl:flex-row xl:items-center justify-between gap-3">
        <h6 className="text-md font-bold text-secondary">Users</h6>
        <div className="flex flex-col md:flex-row gap-4 md:items-center">
          <ProgressChartLabel color="#F46569" title="Level 1 Users" />
          <ProgressChartLabel color="#5856D6" title="Level 2 Users" />
          <ProgressChartLabel color="#FFB195" title="Level 3 Users" />
        </div>
      </div>

      <div className="mt-10">
        <ProgressBar color="#F46569" noOfUsers={level1 ?? 0} level={1} totalUsers={total ?? 0} />
        <ProgressBar color="#5856D6" noOfUsers={level2 ?? 0} level={2} totalUsers={total ?? 0} />
        <ProgressBar color="#FFB195" noOfUsers={level3 ?? 0} level={3} totalUsers={total ?? 0} />
      </div>
    </div>
  );
};

export default ProgressChart;
